import {
  ApiBlueprint,
  PageBlueprint,
  createApiFactory,
  createFrontendPlugin,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/frontend-plugin-api';
import Icon from '@mdi/react';
import { mdiKubernetes } from '@mdi/js';
import { rootRouteRef, clusterDetailRouteRef } from './routes';
import {
  k8sClustersApiRef,
  K8sClustersRestApi,
} from '@internal/plugin-neo4j-k8s-clusters-react';

// ── API (→ global API registry) ─────────────────────────
const k8sClustersApi = ApiBlueprint.make({
  name: 'k8s-clusters-api',
  params: defineParams =>
    defineParams(
      createApiFactory({
        api: k8sClustersApiRef,
        deps: {
          discoveryApi: discoveryApiRef,
          fetchApi: fetchApiRef,
        },
        factory: ({ discoveryApi, fetchApi }) =>
          new K8sClustersRestApi({ discoveryApi, fetchApi }),
      }),
    ),
});

// ── Routes (→ app/routes) ───────────────────────────────
const listPage = PageBlueprint.make({
  params: {
    title: 'K8s Clusters',
    icon: <Icon path={mdiKubernetes} size="20px" />,
    path: '/k8s-clusters',
    routeRef: rootRouteRef,
    noHeader: true,
    loader: () =>
      import('./pages/K8sClustersListPage').then(m => (
        <m.K8sClustersListPage />
      )),
  },
});

const detailPage = PageBlueprint.make({
  name: 'detail',
  params: {
    path: '/k8s-clusters/:k8sClusterId',
    routeRef: clusterDetailRouteRef,
    noHeader: true,
    loader: () =>
      import('./pages/K8sClusterPage').then(m => <m.K8sClusterPage />),
  },
});

export default createFrontendPlugin({
  info: {
    packageJson: () => import('../package.json'),
    manifest: () => import('../catalog-info.yaml'),
  },
  pluginId: 'neo4j-k8s-clusters',
  extensions: [k8sClustersApi, listPage, detailPage],
  routes: {
    root: rootRouteRef,
    clusterDetail: clusterDetailRouteRef,
  },
});
